import { Injectable, QueryList } from "@angular/core";
import { NzMenuItemDirective } from "ng-zorro-antd";

@Injectable()
export class UtilService {
  // 当前选中导航菜单
  private _currentMenuItem: NzMenuItemDirective = null;
  public allMenuCmps: QueryList<NzMenuItemDirective>;

  public get currentMenuItem(): NzMenuItemDirective {
    return this.currentMenuItem;
  }

  public set currentMenuItem(value: NzMenuItemDirective) {
    if (this._currentMenuItem) {
      this._currentMenuItem.nzSelected = false;
    }
    this._currentMenuItem = value;
  }

  /**
   * 激活导航菜单项
   *
   * @param {string} menuName
   * @memberof UtilService
   */
  activateMenu(menuName: string) {
    this.allMenuCmps.forEach(item => {
      const text = (item as any).nativeElement.textContent.trim();
      console.log(item);
      if (text == menuName) {
        setTimeout(() => {
          item.nzSelected = true;
          console.log("sub menu :", item, item.nzSubMenuComponent);
          // item.nzSubMenuComponent.nzOpen = true;
        }, 500);
      } else {
        item.nzSelected = false;
        item.nzSubMenuComponent
          ? (item.nzSubMenuComponent.nzOpen = false)
          : null;
      }
    });
  }

  constructor() {}
}
